import Flickity from "flickity";

export default function() {
  const carouseSelector = ".case-study-carousel";
  if (document.querySelectorAll(carouseSelector).length) {
    const flickityOptions = {
      pageDots: true,
      autoPlay: false,
      watchCSS: true,
      cellAlign: "left",
      prevNextButtons: false,
      adaptiveHeight: true,
      setGallerySize: false,
      wrapAround: true,
      selectedAttraction: 0.01,
      friction: 0.15
    };
    const flkty = new Flickity(carouseSelector, flickityOptions);
  }
}
